// src/routes.js

/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================
*/

// @mui icons
import Icon from "@mui/material/Icon";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import PeopleIcon from "@mui/icons-material/People";
import SecurityIcon from "@mui/icons-material/Security";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import GroupsIcon from "@mui/icons-material/Groups";
import KeyIcon from "@mui/icons-material/Key";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import EventIcon from "@mui/icons-material/Event";
import SpeedIcon from "@mui/icons-material/Speed";
import TrackChangesIcon from "@mui/icons-material/TrackChanges";
import DescriptionIcon from "@mui/icons-material/Description";
import BuildIcon from "@mui/icons-material/Build";
import CasesOutlinedIcon from "@mui/icons-material/CasesOutlined";
import ChecklistRtlIcon from "@mui/icons-material/ChecklistRtl";
import ChatIcon from "@mui/icons-material/Chat";

import SeedMenusFromRoutes from "pages/admin/SeedMenusFromRoutes";
import RequireAccess from "pages/components/RequireAccess";

import TestePostgres from "pages/admin/TestePostgres";
import Dashboard from "pages/dashboard/Dashboard";
import PlaneadorEntregas from "pages/logistics/PlaneadorEntregas";
import Login from "pages/auth/Login";
import Utilizadores from "pages/admin/Utilizadores";
import Acessos from "pages/admin/Acessos";
import Funcoes from "pages/admin/Funcoes";
import AcessosFuncoes from "pages/admin/AcessosFuncoes";
import UtilizadoresFuncoes from "pages/admin/UtilizadoresFuncoes";
import AusenciasCalendario from "pages/admin/AusenciasCalendario";
import AusenciasFuncoes from "pages/admin/AusenciasFuncoes";
import Feriados from "pages/admin/Feriados";
import FuncoesLimites from "pages/admin/FuncoesLimites";
import FuncoesCapacidadeDia from "pages/admin/FuncoesCapacidadeDia";
import AnaliseStocks from "pages/comercial/AnaliseStocks";
import AnaliseVendas from "pages/comercial/AnaliseVendas";
import Objetivos from "pages/comercial/Objetivos";
import FabricantesFornecedores from "pages/comercial/FabricantesFornecedores";
import PropagacaoSubmarcas from "pages/comercial/PropagacaoSubmarcas";
import ResumoAusencias from "pages/admin/ResumoAusencias";
import VendasTransportes from "pages/distribuicao/VendasTransportes";
import VendasTransportesEstatisticas from "pages/distribuicao/VendasTransportesEstatisticas";
import VendasMensaisVendedores from "pages/dashboard/VendasMensaisVendedores";
import FichasTransporte from "pages/distribuicao/FichasTransporte";
import Equipamentos from "pages/equipamentos/Equipamentos";
import Chats from "pages/comunicacao/Chats";
import Telegram from "pages/comunicacao/Telegram";

const routes = [
  // Rota pública de login (fora da sidebar)
  {
    route: "/auth/login",
    component: <Login />,
  },

  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
    headerTitle: "Dashboard",
    subtitle: "Resumo estatístico",
    obs: "Dashboard com estatísticas gerais da atividade",
    public: true,
  },

  // Rota auxiliar (fora da sidebar) para abrir o gráfico em tamanho grande
  {
    route: "/dashboard/vendas-mensais-vendedores",
    component: (
      <RequireAccess acesso="Menu Administração">
        <VendasMensaisVendedores />
      </RequireAccess>
    ),
    headerTitle: "Vendas mensais por vendedor",
    subtitle: "Últimos 13 meses — Top 5 + Outros",
    obs: "Vista fullscreen do gráfico de vendas mensais por vendedor",
    acesso: "Menu Administração",
  },

  {
    type: "collapse",
    name: "Administração",
    key: "percurso",
    icon: <AdminPanelSettingsIcon />,
    collapse: [
      {
        type: "collapse",
        name: "Sincronizar Menus",
        key: "seed-menus",
        icon: <Icon fontSize="small">sync</Icon>,
        route: "/admin/seed-menus",
        // protege por acesso (mesmo vindo por URL)
        component: (
          <RequireAccess acesso="Menu Administração">
            <SeedMenusFromRoutes />
          </RequireAccess>
        ),
        headerTitle: "Sincronizar Menus",
        subtitle: "Gravar no Postgres as rotas visíveis no menu",
        obs: "Seed para app.menu_routes",
        acesso: "Menu Administração",
      },
      {
        type: "collapse",
        name: "Utilizadores e Funcionários",
        key: "utilizadores",
        icon: <PeopleIcon />,
        route: "/administracao/utilizadores",
        component: (
          <RequireAccess acesso="Menu Administração">
            <Utilizadores />
          </RequireAccess>
        ),
        headerTitle: "Utilizadores e Funcionários",
        subtitle: "Tabela e edição de utilizadores e funcionários",
        obs: "Utilizadores com login à app, e funcionários sem login",
        acesso: "Menu Administração",
      },
      {
        type: "collapse",
        name: "Acessos",
        key: "acessos",
        icon: <SecurityIcon />,
        route: "/administracao/acessos",
        component: (
          <RequireAccess acesso="Menu Administração">
            <Acessos />
          </RequireAccess>
        ),
        headerTitle: "Acessos",
        subtitle: "Tabela e edição de acessos aos menus da sidebar",
        obs: "Tabela/lista/edição de acessos aos menus da sidebar",
        acesso: "Menu Administração",
      },
      {
        type: "collapse",
        name: "Funções",
        key: "funcoes",
        icon: <GroupsIcon />,
        route: "/administracao/funcoes",
        component: (
          <RequireAccess acesso="Menu Administração">
            <Funcoes />
          </RequireAccess>
        ),
        headerTitle: "Funções",
        subtitle: "Tabela e edição de funções profissionais",
        obs: "Tabela/lista/edição de funções profissionais",
        acesso: "Menu Administração",
      },
      {
        type: "collapse",
        name: "Acessos por Função",
        key: "acessos-funcoes",
        icon: <KeyIcon />,
        route: "/administracao/acessos-funcoes",
        component: (
          <RequireAccess acesso="Menu Administração">
            <AcessosFuncoes />
          </RequireAccess>
        ),
        headerTitle: "Acessos por Função",
        subtitle: "Permissões R/W/U/D por menu",
        obs: "Tabela e edição de funções com acesso a menus. Permissões R/W/U/D por menu.",
        acesso: "Menu Administração",
      },
      {
        type: "collapse",
        name: "Funções dos Funcionários",
        key: "utilizadores-funcoes",
        icon: <SupervisorAccountIcon />,
        route: "/administracao/utilizadores-funcoes",
        component: (
          <RequireAccess acesso="Menu Administração">
            <UtilizadoresFuncoes />
          </RequireAccess>
        ),
        acesso: "Menu Administração",
        headerTitle: "Funções dos Utilizadores e Funcionários",
        subtitle: "Associação de funções a utilizadores e funcionários",
        obs: "Tabela e edição de funções dos utilizadores e funcionários.",
      },

      {
        type: "collapse",
        name: "Feriados",
        key: "feriados",
        icon: <EventIcon />,
        route: "/admin/feriados",
        component: (
          <RequireAccess acesso="Menu Administração">
            <Feriados />
          </RequireAccess>
        ),
        acesso: "Menu Administração",
        headerTitle: "Feriados",
        subtitle: "Registo de feriados",
        obs: "Feriados nacionais e municipais.",
      },

      {
        type: "collapse",
        name: "Limites por Função (Geral)",
        key: "funcoes-limites",
        icon: <SpeedIcon />,
        route: "/admin/funcoes-limites",
        component: (
          <RequireAccess acesso="Menu Administração">
            <FuncoesLimites />
          </RequireAccess>
        ),
        acesso: "Menu Administração",
        headerTitle: "Limites de Ausências por Função (Geral)",
        subtitle: "Máximo de funcionários que se podem ausentar no mesmo dia, por função (Geral)",
        obs: "Máximo de funcionários que podem faltar ao trabalho no mesmo dia, por função. Para férias, ou outros motivos. 0 = indisponível.",
      },

      {
        type: "collapse",
        name: "Limites por Função (Dias)",
        key: "funcoes-capacidade-dia",
        icon: <SpeedIcon />,
        route: "/admin/funcoes-capacidade-dia",
        component: (
          <RequireAccess acesso="Menu Administração">
            <FuncoesCapacidadeDia />
          </RequireAccess>
        ),
        acesso: "Menu Administração",
        headerTitle: "Limites de Ausências por Função (Dias Específicos)",
        subtitle:
          "Máximo de funcionários que se podem ausentar no mesmo dia, por função (Dias Específicos)",
        obs: "Máximo de funcionários que podem faltar ao trabalho no mesmo dia, por função. Para férias, ou outros motivos. 0 = indisponível.",
      },

      {
        type: "collapse",
        name: "Ausências: Associação de Funções",
        key: "ausencias-funcoes",
        icon: <GroupsIcon />,
        route: "/admin/ausencias-funcoes",
        component: (
          <RequireAccess acesso="Menu Administração">
            <AusenciasFuncoes />
          </RequireAccess>
        ),
        acesso: "Menu Administração",
        headerTitle: "Ausências: Associação de Funções",
        subtitle: "Associação entre funções base e respetivas funções gestoras de ausências",
        obs: "",
      },
    ],
  },

  {
    type: "collapse",
    name: "Calendário",
    key: "calendario",
    icon: <CalendarMonthIcon />,
    acesso: "Acesso Geral",
    collapse: [
      {
        type: "collapse",
        name: "Calendário de Ausências",
        key: "cal-ausencias",
        icon: <CalendarMonthIcon />,
        route: "/admin/ausencias",
        component: (
          <RequireAccess acesso="Acesso Geral">
            <AusenciasCalendario />
          </RequireAccess>
        ),
        acesso: "Acesso Geral",
        headerTitle: "Calendário de Ausências",
        subtitle: "Planeamento de ausências de funcionários",
        obs: "Neste calendário registam-se pedidos e validações de ausências de funcionários. Por exemplo, para férias.",
      },
      {
        type: "collapse",
        name: "Resumo de Ausências",
        key: "resumo-ausencias",
        icon: <TrackChangesIcon />,
        route: "/admin/resumo-ausencias",
        component: (
          <RequireAccess acesso="Menu Gestão Ausências">
            <ResumoAusencias />
          </RequireAccess>
        ),
        acesso: "Menu Gestão Ausências",
        headerTitle: "Resumo de Ausências",
        subtitle: "Totais por funcionário (validados / por gozar / pendentes / recusados)",
        obs: "Resumo anual por funcionário.",
      },
    ],
  },

  {
    type: "collapse",
    name: "Comercial",
    key: "comercial",
    icon: <BusinessCenterIcon />,
    acesso: "Menu Comercial",
    collapse: [
      {
        type: "collapse",
        name: "Fabricantes e Fornecedores",
        key: "fabricantes-fornecedores",
        icon: <CasesOutlinedIcon />,
        route: "/comercial/fabricantes-fornecedores",
        component: (
          <RequireAccess acesso="Menu Administração">
            <FabricantesFornecedores />
          </RequireAccess>
        ),
        acesso: "Menu Administração",
        headerTitle: "Associação de Fabricantes a Fornecedores",
        subtitle:
          "Ligação manual entre fabricantes e fornecedores, com consulta das associações atuais",
        obs: "Página de associação entre fabricantes e fornecedores.",
      },
      {
        type: "collapse",
        name: "Análise de Stocks",
        key: "analise-stocks",
        icon: <SpeedIcon />,
        route: "/comercial/analise-stocks",
        component: (
          <RequireAccess acesso="Menu Comercial">
            <AnaliseStocks />
          </RequireAccess>
        ),
        acesso: "Menu Comercial",
        headerTitle: "Análise de Stocks",
        subtitle: "Cobertura de stocks por material e fabricante, com previsão de rutura de stocks",
        obs: "Análise de stocks com dias de rutura (média ano e máximo dos 2 meses seguintes).",
      },
      {
        type: "collapse",
        name: "Análise de Vendas",
        key: "analise-vendas",
        icon: <SpeedIcon />,
        route: "/comercial/analise-vendas",
        component: (
          <RequireAccess acesso="Menu Comercial">
            <AnaliseVendas />
          </RequireAccess>
        ),
        acesso: "Menu Comercial",
        headerTitle: "Análise de Vendas",
        subtitle: "Faturação por período, vendedor, cliente e família",
        obs: "Análise de vendas da equipa comercial, por períodos.",
      },
      {
        type: "collapse",
        name: "Objetivos",
        key: "objetivos",
        icon: <TrackChangesIcon />,
        route: "/comercial/objetivos",
        component: (
          <RequireAccess acesso="Menu Comercial">
            <Objetivos />
          </RequireAccess>
        ),
        acesso: "Menu Comercial",
        headerTitle: "Objetivos",
        subtitle:
          "Listagem e definição de campanhas de objetivos (filtros + equipas + individuais)",
      },
      {
        type: "collapse",
        name: "Propagação de Submarcas",
        key: "propagacao-submarcas",
        icon: <ChecklistRtlIcon />,
        route: "/comercial/propagacao-submarcas",
        component: (
          <RequireAccess acesso="Menu Comercial">
            <PropagacaoSubmarcas />
          </RequireAccess>
        ),
        acesso: "Menu Comercial",
        headerTitle: "Propagação de Submarcas",
        subtitle: "Submarcas compradas por cliente, por período, vendedor e rota",
        obs: "Matriz de clientes por submarca, com filtros de fabricantes, marcas e submarcas.",
      },
    ],
  },

  {
    type: "collapse",
    name: "Distribuição",
    key: "distribuicao",
    icon: <LocalShippingIcon />,
    acesso: "Acesso Geral",
    collapse: [
      {
        type: "collapse",
        name: "Fichas de Transporte",
        key: "fichas-transporte",
        icon: <DescriptionIcon />,
        route: "/distribuicao/fichas-transporte",
        component: (
          <RequireAccess acesso="Menu Distribuição">
            <FichasTransporte />
          </RequireAccess>
        ),
        headerTitle: "Fichas de Transporte",
        subtitle: "Registo e consulta de fichas de transporte",
        obs: "dataficha > reftransporte",
        acesso: "Menu Distribuição",
      },
      {
        type: "collapse",
        name: "Transportes",
        key: "transportes",
        icon: <LocalShippingIcon />,
        route: "/distribuicao/transportes",
        component: (
          <RequireAccess acesso="Acesso Geral">
            <VendasTransportes />
          </RequireAccess>
        ),
        acesso: "Acesso Geral",
        headerTitle: "Transportes",
        subtitle:
          "Análise de transportes (filtros por período, matrícula, distribuidor, status, vendedor e cliente)",
        obs: "Tabela de transportes, cargas, entregas, com filtros e detalhes de faturas.",
      },
      {
        type: "collapse",
        name: "Estatísticas de Entregas",
        key: "estatisticas-entregas",
        icon: <TrackChangesIcon />,
        route: "/distribuicao/estatisticas-entregas",
        component: (
          <RequireAccess acesso="Menu Distribuição">
            <VendasTransportesEstatisticas />
          </RequireAccess>
        ),
        headerTitle: "Estatísticas de Entregas",
        subtitle: "Análise por distribuidor, dia e transporte",
        obs: "Agregado por pessoa > datafim > reftransporte",
        acesso: "Menu Distribuição",
      },
    ],
  },

  {
    type: "collapse",
    name: "Equipamentos",
    key: "equipamentos",
    icon: <BuildIcon />,
    acesso: "Menu Equipamentos",
    collapse: [
      {
        type: "collapse",
        name: "Equipamentos",
        key: "equipamentos-cadastro",
        icon: <BuildIcon />,
        route: "/equipamentos/equipamentos",
        component: (
          <RequireAccess acesso="Menu Equipamentos">
            <Equipamentos />
          </RequireAccess>
        ),
        acesso: "Menu Equipamentos",
        headerTitle: "Equipamentos",
        subtitle: "Cadastro de equipamentos e dados base",
        obs: "Tabela e edição do cadastro de equipamentos",
      },
    ],
  },

  {
    type: "collapse",
    name: "Comunicação",
    key: "comunicacao",
    icon: <ChatIcon />,
    acesso: "Menu Administração",
    collapse: [
      {
        type: "collapse",
        name: "Chats",
        key: "comunicacao-chats",
        icon: <ChatIcon />,
        route: "/comunicacao/chats",
        component: (
          <RequireAccess acesso="Menu Administração">
            <Chats />
          </RequireAccess>
        ),
        acesso: "Menu Administração",
        headerTitle: "Chats",
        subtitle: "Comunicação interna entre utilizadores e equipas",
        obs: "Módulo de comunicação interna com chats, mensagens, menções e anexos.",
      },
    ],
  },

  {
    route: "/comunicacao/telegram",
    component: (
      <RequireAccess acesso="Menu Administração">
        <Telegram />
      </RequireAccess>
    ),
    acesso: "Menu Administração",
    headerTitle: "Telegram",
    subtitle: "Ligação da conta Telegram para notificações",
  },

  {
    route: "/comunicacao/chats/:idchat/:idmensagem?",
    component: (
      <RequireAccess acesso="Menu Administração">
        <Chats />
      </RequireAccess>
    ),
    acesso: "Menu Administração",
    headerTitle: "Chats",
    subtitle: "Comunicação interna entre utilizadores e equipas",
    obs: "Abertura direta de chat ou mensagem específica.",
  },

  {
    type: "collapse",
    name: "Qualidade",
    key: "qualidade",
    icon: <AssignmentTurnedInIcon />,
    acesso: "Menu Qualidade",
    collapse: [
      // ...
    ],
  },

  // Exemplos desativados (mantidos como referência):
  // {
  //   type: "collapse",
  //   name: "Planeador Entregas",
  //   key: "planeador-entregas",
  //   icon: <LocationOnIcon fontSize="small" />,
  //   route: "/logistics/planeador-entregas",
  //   component: <PlaneadorEntregas />,
  //   headerTitle: "Planeador Entregas",
  //   subtitle: "Testando rotas de entregas.",
  //   obs: "",
  // },
];

export default routes;
